/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumEdsGradients } from "@cosmos/hygraph-schema";
import { token } from "@panda/tokens";
import { CSSProperties } from "react";
import { css, cx } from "@panda/css";
import { CosmosTitle, CosmosTitleProps } from "./CosmosTitle.molecule";

export interface ColorfulTitleProps extends CosmosTitleProps {
	gradient?: CosmosEnumEdsGradients | null;
}

interface CssVariables extends CSSProperties {
	"--cosmos-gradient"?: string;
}

const styles = css({
	"&& a": {
		background: "var(--cosmos-gradient)",
		backgroundClip: "text",
		color: "transparent",
	},
	"& .paragraph": {
		color: "eds.text.primary",
	},
	"& a[href]": {
		_hover: {
			color: "eds.text.primary",
		},
	},
	'& a[href="#"]': {
		pointerEvents: "none",
		textDecoration: "none",
		cursor: "default",
	},
});

export const ColorfulTitle = (props: ColorfulTitleProps): React.JSX.Element => {
	let gradient = props?.gradient;
	if (!gradient) gradient = CosmosEnumEdsGradients.Indigo;

	return (
		<CosmosTitle
			style={{ "--cosmos-gradient": token(`gradients.eds.gradient.${gradient}`) } as CssVariables}
			{...props}
			className={cx("colorful-title", styles, props.className)}
		/>
	);
};
